import branchManagementBagoutsComponent from './bagouts.component';
import PrintModule from './print';

let branchManagementBagoutsModule = angular.module('branchManagementBagoutsHistory', [PrintModule])
  .component('branchManagementBagoutsHistory', branchManagementBagoutsComponent)
  .name;

export default branchManagementBagoutsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/index.js